import { isBrowser } from '~/shared/utils/platform';

export const isDevice = () => isBrowser && window.matchMedia('(max-width: 768px)').matches;
